import { render, staticRenderFns } from "./WebNewsList.vue?vue&type=template&id=d38adb96&"
import script from "./WebNewsList.vue?vue&type=script&lang=js&"
export * from "./WebNewsList.vue?vue&type=script&lang=js&"
import style0 from "./WebNewsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports